/* models/layouts/html_box */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var layout_dom_1 = require(166) /* ../layouts/layout_dom */;
    var layout_1 = require(13) /* ../../core/layout */;
    var HTMLBoxView = /** @class */ (function (_super) {
        tslib_1.__extends(HTMLBoxView, _super);
        function HTMLBoxView() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(HTMLBoxView.prototype, "child_models", {
            get: function () {
                return [];
            },
            enumerable: true,
            configurable: true
        });
        HTMLBoxView.prototype._update_layout = function () {
            this.layout = new layout_1.ContentBox(this.el);
            this.layout.set_sizing(this.box_sizing());
        };
        HTMLBoxView.__name__ = "HTMLBoxView";
        return HTMLBoxView;
    }(layout_dom_1.LayoutDOMView));
    exports.HTMLBoxView = HTMLBoxView;
    var HTMLBox = /** @class */ (function (_super) {
        tslib_1.__extends(HTMLBox, _super);
        function HTMLBox(attrs) {
            return _super.call(this, attrs) || this;
        }
        HTMLBox.__name__ = "HTMLBox";
        return HTMLBox;
    }(layout_dom_1.LayoutDOM));
    exports.HTMLBox = HTMLBox;
}
